const namespace = {
  header: {
    title: "IO reports: discover the story behind any neighborhood",
    description:
      "Our IO Reports give you a clear, easy-to-digest snapshot of any area you’re exploring. From what it feels like to live there, to how the local market is moving. Whether you’re looking for vibrant streets, quiet corners, or strong investment potential, our Location Insights and Market Activity reports help you make confident, informed decisions about where to call home.",
  },
} as const;

export default namespace;
